import { INVITATION_TYPE } from "../../../enums/Enums";

export class InvitationEntity {
    inviterName;
    inviterId;
    email;
    phone;
    scopeId;
    roleId;
    scopeName;
    invitationType;
  
    constructor(inviterName, inviterId, email, phone, scopeId, roleId, scopeName, invitationType = INVITATION_TYPE.GMT) {
      this.inviterName = inviterName;
      this.inviterId = inviterId;
      this.email = email;
      this.phone = phone;
      this.scopeId = scopeId;
      this.roleId = roleId;
      this.scopeName = scopeName;
      this.invitationType = invitationType;
    }
  }
  